@if (enableSharedComponent) {
  <app-sidebar />
}
@if (showKnowledgeBaseBubble) {
  <app-knowledge-base-bubble />
}
<app-toast-container />
<main [@routeAnimations]="getRouteAnimationData()" class="route-container">
  <router-outlet />
</main>
